import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-navigations',
  templateUrl: './side-navigations.component.html',
  styleUrls: ['./side-navigations.component.scss']
})

export class SideNavigationsComponent implements OnInit {

  permissionAsssign: any[] = [];
  rolesAsssign: any[] = [];
  customize: boolean = true;
  expand: boolean = false; 
  showUser: boolean = false;
  showPermission: boolean = false;
  showRole: boolean = false;
  showOrganization: boolean = false;
  showModule: boolean = false;
  rolesShow:boolean=false;
  showLoginDetails: boolean = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {   
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    if(this.rolesAsssign.length > 0){
      var role=[];
       // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
       // roleLevel:11 (User)
      role= this.rolesAsssign.filter((m) => m.roleLevel == 1); // roleLevel:1 (Super admin)
      if(role.length > 0){
        this.showUser=true;
        this.showPermission=true;
        this.showRole=true;
        this.showModule=true;
        this.showLoginDetails=true;
        return;
     }
     role= this.rolesAsssign.filter((m) => m.roleLevel == 2); //  roleLevel:2 (Organization Admin)
     if(role.length > 0){
      this.showUser=true;
      this.showPermission=true;
      this.showRole=true;
      this.showModule=false;
      this.showLoginDetails=false;
      return;
     }
     role= this.rolesAsssign.filter((m) => m.roleLevel == 3); // roleLevel:3 (Office Admin),
     if(role.length > 0){
      this.showUser=true;
      this.showPermission=false;
      this.showRole=false;
      this.showModule=false;
      this.showLoginDetails=false;
     }
    }

  //   if(this.rolesShow==true){
  //     this.showUser=true;
  //     this.showPermission=true;
  //     this.showRole=true;
  //     this.showOrganization=true;
  //     this.showModule=true; 
  //     return;
  //   }

  //   if(this.rolesShow==false){
  //     if(this.permissionAsssign.length > 0){
  //       for (var i = 0, len = this.permissionAsssign.length; i < len; ++i) {
  //         var menu = this.permissionAsssign[i].permissionName;
                 
  //         if(menu == "User"){
  //           this.showUser=true;  
  //         }
  //         if(menu == "Permission"){
  //           this.showPermission=true;  
  //         }
  //         if(menu == "Role"){
  //           this.showRole=true;  
  //         }
  //         if(menu == "Organization" && this.rolesShow!=false){
  //           this.showOrganization=true;  
  //         }
  //         if(menu == "Module" && this.rolesShow!=false){
  //           this.showModule=true;  
  //         }
  //      } 
  //   } 
  //  }
   

  }

  openOrg(){  
    this.router.navigate(['/organization']);
  }


  expandNav(){
    this.expand = !this.expand
  }

  navItems = [
    {
      id: '0',
      name : 'Admin',
      items :[
        {
          name: 'Users',
          link: '/admin',
        },
        {
          name: 'Permissions',
          link: 'permissions'
        },
        {
          name: 'Roles',
          link: 'role'
        },
        {
          name: 'Organization',
          link: 'organization'
        },
        {
          name: 'Module',
          link: 'module'
        }
      ]
    }
  ];  

}


